import React from "react";
import { connect } from "react-redux";

class AccountLedgerType extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone
		}
    }


    componentDidMount(){

	}
	componentWillUnmount(){
    }

  
    render(){

    return(
 					
        <div class="ledgerblc d-none d-lg-block">
        <div class="row">
            <div class="col-12 col-md-4">
                <div class="ldgrhead">Transaction Info</div>
            </div>								
            <div class="col-12 col-md-3">
                <div class="ldgrhead">Transaction ID & Date</div>
            </div>								
            <div class="col-12 col-md">
                <div class="ldgrhead">Debit Amount</div>
            </div>
            <div class="col-12 col-md">
                <div class="ldgrhead">Credit Amount</div>
            </div>
            <div class="col-12 col-md">
                <div class="ldgrhead text-end">Balance</div>
            </div>
            
        </div>
    </div>
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(AccountLedgerType);
